import { range } from 'lodash';

// string symbols codes which are allowed use in email name.
// symbols, digits, uppercase, lowercase
// 35..39, 48..57, 65..90, 97..122

const digitCodes = [48, 58];

const lowerCaseCodes = [97, 123];

const emailDigits = range(...digitCodes);

const emailLowerCaseLetters = range(...lowerCaseCodes);

const allProviderSymbolsArray = [...emailDigits, ...emailLowerCaseLetters];

const multiplierForProvider = allProviderSymbolsArray.length - 1;

export const generateFakeEmail = () => {
  const emailNameLength = Math.round(Math.random() * 20) + 1;
  const emailProviderLength = Math.round(Math.random() * 20) + 1;

  const emailName = generateSymbolsArray(
    multiplierForProvider,
    emailNameLength,
    allProviderSymbolsArray,
  );
  const emailProvider = generateSymbolsArray(
    multiplierForProvider,
    emailProviderLength,
    allProviderSymbolsArray,
  );

  if (!emailName.length || !emailName.length) return generateFakeEmail();

  return `${String.fromCharCode(...emailName)}@${String.fromCharCode(...emailProvider)}.org`;
};

const generateSymbolsArray = (multiplier, length, symbolsArray) => {
  let newSymbolsArray = [];

  for (let i = 0; i <= length; i++) {
    const index = Math.round(Math.random() * multiplier);
    const symbolCode = symbolsArray[index];

    newSymbolsArray.push(symbolCode);
  }

  return newSymbolsArray;
};
